import "./header.css";
import { Controller as BaseController } from "@hotwired/stimulus";

export class Controller extends BaseController {
  static targets = ["toggle", "menu"];

  toggleMenu() {
    const expanded = this.toggleTarget.getAttribute("aria-expanded") === "true";
    const isNowExpanded = !expanded;

    this.toggleTarget.setAttribute("aria-expanded", isNowExpanded);
    this.menuTarget.classList.toggle("Header-navigation-is-open");

    document.body.classList.toggle("no-scroll", isNowExpanded);
  }
}
